import { render, staticRenderFns } from "./ShopOrdersPopup.vue?vue&type=template&id=785959d0&scoped=true&"
import script from "./ShopOrdersPopup.vue?vue&type=script&lang=js&"
export * from "./ShopOrdersPopup.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrdersPopup.vue?vue&type=style&index=0&id=785959d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785959d0",
  null
  
)

export default component.exports